import React from "react";
import {
  Checkbox,
  IconButton,
  ListItem,
  ListItemText,
  MenuList,
  Paper
} from "@material-ui/core";
import { ChevronDown } from "mdi-material-ui";
import { ThemeType } from "@theme";
import { makeStyles } from "@material-ui/core/styles";
import { usePopper } from "@hooks";

export type DropdownCheckboxOption = {
  label: string;
  onClick: () => void;
};

type Props = {
  disabled?: boolean;
  CheckboxProps: Partial<React.ComponentProps<typeof Checkbox>>;
  options: DropdownCheckboxOption[];
};

export function DropdownCheckbox(props: Props) {
  const { CheckboxProps = {} } = props;
  const classes = useStyles({});
  const [iconRef, setIconRef] = React.useState(null);

  const { popper, togglePopper } = usePopper(
    () => iconRef,
    false,
    (popperProps) => <List {...props} onClose={popperProps.closePopper} />
  );

  return (
    <div className={classes.root}>
      <Checkbox disabled={props.disabled} {...CheckboxProps} />
      <span ref={(ref) => setIconRef(ref)}>
        <IconButton
          style={{ position: "relative", left: -8, padding: 8 }}
          onClick={togglePopper}
        >
          <ChevronDown />
        </IconButton>
      </span>
      {popper}
    </div>
  );
}

function List(props: Props & { onClose: () => void }) {
  return (
    <Paper>
      <MenuList>
        {props.options.map((item) => (
          <ListItem
            key={item.label}
            button
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              props.onClose();
              item.onClick();
            }}
          >
            <ListItemText primary={item.label} />
          </ListItem>
        ))}
      </MenuList>
    </Paper>
  );
}

const useStyles = makeStyles((theme: ThemeType) => ({
  root: {
    display: "inline-flex",
    alignItems: "center",
    border: `1px solid ${theme.palette.grey[500]}`,
    borderRadius: 4
  },

  icon: {
    cursor: "pointer"
  }
}));
